// @flow
export const httpErrors: { [key: string]: number } = Object.freeze({
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  REQUEST_TIMEOUT: 408,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
});

export function indexHttpErrors(inHttpErrors: { [key: string]: number }): { [key: number]: string } {
  return Object.keys(inHttpErrors).reduce((obj: { [key: number]: string }, value: string) => {
    obj[inHttpErrors[value]] = value;
    return obj;
  }, {});
}

export const httpErrorsCodeMap = indexHttpErrors(httpErrors);

export function getHttpErrorName(errors: { [key: number]: string }, code: number): string {
  return errors[code];
}



// WEBPACK FOOTER //
// ./src/http/errors.js